/**
 * Denis Callinan
 * Project Andromeda
 * August 6th, 2020
 * AboutBox.js - AboutMe component
 */

// Core
import React from 'react';
import "./AboutBox.css";

// Media
import Drcall from '../../img/drcall.jpg'
import li from '../../img/contact/li.png'
import gh from '../../img/contact/gh.png'
import fb from '../../img/contact/fb.png'

class LogoButton extends React.Component {
    handleClick(event) {
        window.open(this.props.dest);
    }

    render() {
        return(
            <input type="image" className = "mediaLogo" src = {this.props.source}  alt = {this.props.alt} onClick={this.handleClick.bind(this)}/>
        );
    }
}

export default function(props) {
    const fbLink = "https://www.facebook.com/drcall4/";
    const ghLink = "https://github.com/drcall";
    const liLink = "https://www.linkedin.com/in/drcall";
    var skillsId;
    if (props.state.windowWidth <= 950 || props.state.windowWidth > 1050) {
        skillsId = "skill-1";
    } else {
        skillsId = "skill-2";
    }
    return(
        <div className = {props.state.windowWidth > 950 ? "aboutMeGrid":"aboutMeMobile"}>
                <img src = {Drcall} id = "drcall" alt = "Denis Callinan"/>
                <div id = "about-txt-section">
                    <p align = {props.state.windowWidth > 950 ? "right": "center"}>
                        I'm Denis Callinan, and I'm a student at 
                        the <a href = 'https://engineering.virginia.edu/departments/computer-science'>University of Virginia.</a>
                    </p>
                    <p align = {props.state.windowWidth > 950 ? "right": "center"}>
                        For the last several years, I have developed a passion for software development and computer science.
                        Throughout my time in college, I have worked to build my skills throuh coursework, extracurricular initiatives, and internships
                        to fulfill my objective of becoming not only a software engineer but a contributor to a diverse team working on products that 
                        have a positive impact in our everyday lives.
                    </p>
                    <p align = {props.state.windowWidth > 950 ? "right": "center"}>
                        Over the years, I've built different projects, including robots, games, and dashboards. 
                        If you're interested, you can view some of my work below.
                    </p>
                    <p align = {props.state.windowWidth > 950 ? "right": "center"}>
                        In addition, here are some of my favorite technologies that I've utilized:
                    </p>
                    <div className = "skillsGrid" id = {skillsId}>
                        <p id = "skill">React</p>
                        <p id = "skill">Django</p>
                        <p id = "skill">Android</p>
                        <p id = "skill">C/C++</p>
                        <p id = "skill">Python</p>
                        <p id = "skill">Java</p>
                    </div>
                </div>
                <div id = {props.state.windowWidth > 950 ? "media-grid": "media-mobile"}>
                    <LogoButton source = {li} alt = "To LinkedIn" dest = {liLink} />
                    <LogoButton source = {gh} alt = "To GitHub" dest = {ghLink} />
                    <LogoButton source = {fb} alt = "To Facebook" dest = {fbLink} />
                </div>
            </div>
    )
}